import request from "@/utils/request.js";

export const ReplySettingsApi = (data) => {
    return request.get("/hotel/reply-settings",data);
};
export const ReplySettingsPutApi = (data) => {
    return request.put("/hotel/reply-settings",data);
};

export const authMe = (data) => {
    return request.get("/auth/me",data);
};

export const RestaurantReplySettingsApi = (data) => {
    return request.get("/restaurant/reply-settings",data);
};
export const RestaurantReplySettingsPutApi = (data) => {
    return request.put("/restaurant/reply-settings",data);
};